
/**
 * reducers/initializers.js 
 * 
 * react-redux reducer initializers
 */ 

// Set up initial state of some global variables using constants
export const initialStateGlobal = {
    map: null,
    satellite: false,
    entities: [],
    id: null,
    name: "Untitled plan",
    public: false,
    entityid: null,
    entity: null,
    data: [],
    funding: null,
};

